import { Outlet, RouteObject } from 'react-router-dom';

import { FeatureFlaggedPage } from '@eluve/smart-blocks';

import { LayersPage } from './LayersPage';
import { LocationPage } from './LocationPage';
import { LocationsPage } from './LocationsPage';
import { SessionTypesPage } from './SessionTypesPage';
import { UserGroupDetailsPage } from './UserGroupDetailsPage';
import { UserGroupsListPage } from './UserGroupsListPage';
import { UsersPage } from './Users';
import { GeneralTenantSettingsPage } from './general-tenant-settings';

export const tenantAdminRoutes = [
  {
    path: 'user-groups',
    element: (
      <FeatureFlaggedPage flag="USER_GROUPS">
        <Outlet />
      </FeatureFlaggedPage>
    ),
    children: [
      {
        index: true,
        element: <UserGroupsListPage />,
      },
      {
        path: ':userGroupId',
        element: <UserGroupDetailsPage />,
      },
    ],
  },
  {
    path: 'layers',
    element: (
      <FeatureFlaggedPage flag="LOCATIONS">
        <LayersPage />
      </FeatureFlaggedPage>
    ),
  },
  {
    path: 'locations',
    element: (
      <FeatureFlaggedPage flag="LOCATIONS">
        <Outlet />
      </FeatureFlaggedPage>
    ),
    children: [
      {
        index: true,
        element: <LocationsPage />,
      },
      {
        path: ':locationId',
        element: <LocationPage />,
      },
    ],
  },
  {
    path: 'session-types',
    element: (
      <FeatureFlaggedPage flag="SESSION_TYPES">
        <SessionTypesPage />
      </FeatureFlaggedPage>
    ),
  },
  {
    path: 'general',
    element: <GeneralTenantSettingsPage />,
  },
  {
    path: 'users',
    element: <UsersPage />,
  },
] satisfies RouteObject[];
